import { render, staticRenderFns } from "./FactorInvoiceView.vue?vue&type=template&id=57ae1988"
import script from "./FactorInvoiceView.vue?vue&type=script&lang=js"
export * from "./FactorInvoiceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57ae1988')) {
      api.createRecord('57ae1988', component.options)
    } else {
      api.reload('57ae1988', component.options)
    }
    module.hot.accept("./FactorInvoiceView.vue?vue&type=template&id=57ae1988", function () {
      api.rerender('57ae1988', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/factorinvoice/FactorInvoiceView.vue"
export default component.exports